import React from "react";
import { UserInterface } from "../../../../store/roblox/usersSlice";
import { formattedDate } from "../../../../helpers/DateHelpers";

import Title from "./_Title";
import Meta, { MetaInterface } from "../../../../componets/Meta";
import { UserOutlined } from "@ant-design/icons";

interface _MetaInterface {
  user: UserInterface | undefined;
  size?: MetaInterface['size'];
  shape?: MetaInterface['shape'];
  className?: string;
}

const _Meta = ({ user, shape, size, className }: _MetaInterface) => {
  if (!user) {
    return null;
  }

  return (
    <Meta
      url={user.url}
      size={size}
      shape={shape}
      avatar={user.avatar_url}
      fallback={UserOutlined}
      title={<Title name={user.name} bannedUntil={user.banned_until} mutedUntil={user.muted_until} />}
      description={
        <small>{`Seen: ${formattedDate(user.launch_at).fromNow}`}</small>
      }
      className={className}
    />
  );
}

export default _Meta;
